import type { ActionContext } from "vuex";
import type { RootState } from "@/store";
import { $http } from "@/utils/https";

type Currency = 'CZK' | 'EUR';

interface Region {
    "id": number,
    "name": string,
    "alpha2Code": string,
    "currency": Currency,
    "isDefault": boolean
}

interface State {
    regionsList: Array<Region> | null;
    regionsListLoaded: boolean;
    currentRegion: any;
}

const state: State = {
    regionsList: null,
    regionsListLoaded: false,
    currentRegion: null,
}

const getters = {
    regionsList: (state: State) => state.regionsList,
    regionsListLoaded: (state: State) => state.regionsListLoaded,
    currentRegion: (state: State) => state.currentRegion,
    currentRegionCurrency: (state: State) => state.currentRegion?.currency,
}

const actions = {
    GET_REGIONS_LIST: async ({commit}: ActionContext<State, RootState>) => {
        commit('SET_REGIONS_LIST', []);
        commit('SET_REGIONS_LIST_LOADED', false);
        try {
            const response = await $http.get(`v1/regions/list`);
            const transformedData = response.data.map((item: any) => {
                if(item.name === 'Czechia') {
                    return {
                        ...item,
                        name: 'Czech Republic'
                    }
                }
                return item;
            });
            transformedData.push({
                "id": -2,
                "name": "Ukraine",
                "alpha2Code": "UA",
                "currency": "EUR",
                "isDefault": false
            })
            commit('SET_REGIONS_LIST', transformedData);
            commit('SET_REGIONS_LIST_LOADED', true);
            return transformedData;
        } catch (e) {
            throw e;
        } finally {}
    },
}

const mutations = {
    SET_REGIONS_LIST(state: State, value: any) {
        state.regionsList = value;
    },
    SET_REGIONS_LIST_LOADED(state: State, value: boolean) {
        state.regionsListLoaded = value;
    },
    SET_CURRENT_REGION(state: State, value: any) {
        state.currentRegion = value;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
